import { AdbScrcpyForwardConnection, AdbScrcpyReverseConnection, } from "../connection.js";
import { AdbScrcpyOptions1_16 } from "./1_16.js";
export class AdbScrcpyOptions1_22 extends AdbScrcpyOptions1_16 {
    createConnection(adb) {
        const options = {
            ...this.getDefaultValue(),
            ...this.value,
        };
        if (this.value.tunnelForward) {
            return new AdbScrcpyForwardConnection(adb, options);
        }
        else {
            return new AdbScrcpyReverseConnection(adb, options);
        }
    }
}
//# sourceMappingURL=1_22.js.map